import React, { useState, useEffect } from 'react';
import {object, func, bool} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import {useEntidad} from '../../hooks/useEntidad';
import {isEmptyString, isValidNumber, OnKeyPress_validInteger} from '../../../utils/validator';
import InputEntidad from '../../common/InputEntidad';
import InputLista from '../../common/InputLista';
import DatePickerCustom from '../../common/DatePickerCustom';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import InputNumber from '../../common/InputNumber';
import {TIPS} from "../../../consts/tips";
import {Accordion, CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, Modal} from '../../common';

const SuperficieModal = (props) => {

    const entityInit = {
        id: 0,
        idInmueble: 0,
        nroSuperficie: "",
        nroInterno: "",
        nroDeclaracionJurada: "",
        idTipoSuperficie: 0,
        metros: 0,
        plano: "",
        idGrupoSuperficie: 0,
        idTipoObraSuperficie: 0,
        idDestinoSuperficie: 0,
        fechaIntimacion: null,
        nroIntimacion: "",
        nroAnterior: "",
        fechaPresentacion: null,
        fechaVigenteDesde: null,
        fechaRegistrado: null,
        fechaPermisoProvisorio: null,
        fechaAprobacion: null,
        conformeObra: false,
        fechaFinObra: null,
        ratificacion: "",
        derechos: ""
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        adicionales: false,
        listSuperficies: [],
    });

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoSuperficie'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoSuperficie',
            timeout: 0
        }
    });

    const mount = () => {
        formSet({
            nroSuperficie: props.data.entity.nroSuperficie,
            nroInterno: props.data.entity.nroInterno,
            nroDeclaracionJurada: props.data.entity.nroDeclaracionJurada,
            idTipoSuperficie: props.data.entity.idTipoSuperficie,
            metros: props.data.entity.metros,
            plano: props.data.entity.plano,
            idGrupoSuperficie: props.data.entity.idGrupoSuperficie,
            idTipoObraSuperficie: props.data.entity.idTipoObraSuperficie,
            idDestinoSuperficie: props.data.entity.idDestinoSuperficie,
            fechaIntimacion: props.data.entity.fechaIntimacion,
            nroIntimacion: props.data.entity.nroIntimacion,
            nroAnterior: props.data.entity.nroAnterior,
            fechaPresentacion: props.data.entity.fechaPresentacion,
            fechaVigenteDesde: props.data.entity.fechaVigenteDesde,
            fechaRegistrado: props.data.entity.fechaRegistrado,
            fechaPermisoProvisorio: props.data.entity.fechaPermisoProvisorio,
            fechaAprobacion: props.data.entity.fechaAprobacion,
            conformeObra: props.data.entity.conformeObra,
            fechaFinObra: props.data.entity.fechaFinObra,
            ratificacion: props.data.entity.ratificacion,
            derechos: props.data.entity.derechos
        });
        let adicionales = false;
        if (props.data.entity.idTipoSuperficie !== 0) {
            const row = getRowEntidad('TipoSuperficie', props.data.entity.idTipoSuperficie);
            adicionales = (row) ? row.adicionales : false;
        }

        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity,
                listSuperficies: props.data.listSuperficies,
                adicionales: adicionales
            }
        });
    }
    useEffect(mount, [props.data.entity, props.data.listSuperficies]);

    const [formValues, formHandle, , formSet] = useForm({
        nroSuperficie: "",
        nroInterno: "",
        nroDeclaracionJurada: "",
        idTipoSuperficie: 0,
        metros: 0,
        plano: "",
        idGrupoSuperficie: 0,
        idTipoObraSuperficie: 0,
        idDestinoSuperficie: 0,
        fechaIntimacion: null,
        nroIntimacion: "",
        nroAnterior: "",
        fechaPresentacion: null,
        fechaVigenteDesde: null,
        fechaRegistrado: null,
        fechaPermisoProvisorio: null,
        fechaAprobacion: null,
        conformeObra: false,
        fechaFinObra: null,
        ratificacion: "",
        derechos: ""
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.nroSuperficie = formValues.nroSuperficie;
        row.nroInterno = formValues.nroInterno;
        row.nroDeclaracionJurada = formValues.nroDeclaracionJurada;
        row.idTipoSuperficie = parseInt(formValues.idTipoSuperficie);
        row.metros = formValues.metros;
        row.plano = formValues.plano;
        row.idGrupoSuperficie = !isEmptyString(formValues.idGrupoSuperficie) ? parseInt(formValues.idGrupoSuperficie) : 0;
        row.idTipoObraSuperficie = !isEmptyString(formValues.idTipoObraSuperficie) ? parseInt(formValues.idTipoObraSuperficie) : 0;
        row.idDestinoSuperficie = !isEmptyString(formValues.idDestinoSuperficie) ? parseInt(formValues.idDestinoSuperficie) : 0;
        row.fechaIntimacion = formValues.fechaIntimacion;
        row.nroIntimacion = formValues.nroIntimacion;
        row.nroAnterior = formValues.nroAnterior;
        row.fechaPresentacion = formValues.fechaPresentacion;
        row.fechaVigenteDesde = formValues.fechaVigenteDesde;
        row.fechaRegistrado = formValues.fechaRegistrado;
        row.fechaPermisoProvisorio = formValues.fechaPermisoProvisorio;
        row.fechaAprobacion = formValues.fechaAprobacion;
        row.conformeObra = formValues.conformeObra;
        row.fechaFinObra = formValues.fechaFinObra;
        row.ratificacion = formValues.ratificacion;
        row.derechos = formValues.derechos;

        props.onConfirm(row);
    };

    const handleChangeTipoSuperficie = (event) => {
        const {target} = event;
        let idTipoSuperficie = 0;
        let adicionales = false;
        if (target.row) {
            idTipoSuperficie = parseInt(target.value);
            adicionales = target.row.adicionales;
        }

        formSet({
            ...formValues,
            idTipoSuperficie: idTipoSuperficie,
            nroInterno: "",
            nroDeclaracionJurada: "",
            idGrupoSuperficie: 0,
            idTipoObraSuperficie: 0,
            idDestinoSuperficie: 0,
            fechaIntimacion: null,
            nroIntimacion: "",
            nroAnterior: "",
            fechaPresentacion: null,
            fechaVigenteDesde: null,
            fechaRegistrado: null,
            fechaPermisoProvisorio: null,
            fechaAprobacion: null,
            conformeObra: false,
            fechaFinObra: null
        });
        setState(prevState => {
            return {...prevState, adicionales: adicionales};
        });

    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.nroSuperficie.length === 0) errors.nroSuperficie = VALIDATION_MESSAGE.REQUIRED_SHORT;
        else if (state.listSuperficies.includes(formValues.nroSuperficie)) errors.nroSuperficie = 'Ya existe';
        if (formValues.idTipoSuperficie <= 0) errors.idTipoSuperficie = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (!isValidNumber(formValues.metros, true)) errors.metros = 'Ingresá un número mayor a cero';

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Superficie: ${(state.entity.id > 0) ? state.entity.nroSuperficie : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.SUPERFICIE_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="row">
                                                <div className="mb-3 col-6 col-md-2">
                                                    <FormLabel htmlFor="nroSuperficie"
                                                           required>Número</FormLabel>
                                                    <input
                                                        name="nroSuperficie"
                                                        type="text"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('nroSuperficie') ? 'is-invalid' : ''}`}
                                                        value={formValues.nroSuperficie}
                                                        onChange={formHandle}
                                                        onKeyPress={OnKeyPress_validInteger}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('nroSuperficie')} />
                                                </div>
                                                <div className="mb-3 col-12 col-md-5">
                                                    <FormLabel htmlFor="idTipoSuperficie"
                                                           required>Tipo</FormLabel>
                                                    <InputEntidad
                                                        name="idTipoSuperficie"
                                                        placeholder=""
                                                        tipName={TIPS.NAME.MODALS.TIPO_SUPERFICIE_MODAL}
                                                        className={`form-control ${errorOf('idTipoSuperficie') ? 'is-invalid' : ''}`}
                                                        value={formValues.idTipoSuperficie}
                                                        onChange={handleChangeTipoSuperficie}
                                                        disabled={props.disabled}
                                                        title="Tipo superficie"
                                                        entidad="TipoSuperficie"
                                                    />
                                                    <FormError message={errorOf('idTipoSuperficie')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-3">
                                                    <FormLabel htmlFor="metros" required>Metros
                                                        cuadrados</FormLabel>
                                                    <InputNumber
                                                        name="metros"
                                                        placeholder=""
                                                        className={`form-control ${errorOf('metros') ? 'is-invalid' : ''}`}
                                                        value={formValues.metros}
                                                        precision={2}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError message={errorOf('metros')} />
                                                </div>
                                                <div className="mb-3 col-6 col-md-2">
                                                    <label htmlFor="plano" className="form-label">Plano</label>
                                                    <input
                                                        name="plano"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.plano}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                    <FormError />
                                                </div>
                                            </div>
                                            {state.adicionales &&
                                                <div className="row">
                                                    <div className="mb-3 col-6 col-md-5">
                                                        <label htmlFor="nroInterno" className="form-label">Número
                                                            interno</label>
                                                        <input
                                                            name="nroInterno"
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control"
                                                            value={formValues.nroInterno}
                                                            onChange={formHandle}
                                                            onKeyPress={OnKeyPress_validInteger}
                                                            disabled={props.disabled}
                                                        />
                                                    </div>
                                                    <div className="mb-3 col-6 col-md-7">
                                                        <label htmlFor="nroDeclaracionJurada"
                                                               className="form-label">N° Declaración
                                                            jurada</label>
                                                        <input
                                                            name="nroDeclaracionJurada"
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control"
                                                            value={formValues.nroDeclaracionJurada}
                                                            onChange={formHandle}
                                                            onKeyPress={OnKeyPress_validInteger}
                                                            disabled={props.disabled}
                                                        />
                                                    </div>
                                                </div>
                                            }
                                            {state.adicionales &&
                                                <>
                                                    <hr className="solid m-bottom-10"></hr>
                                                    <div className="row">
                                                        <div className="mb-3 col-12 col-md-4">
                                                            <label htmlFor="idGrupoSuperficie"
                                                                   className="form-label">Grupo</label>
                                                            <InputEntidad
                                                                name="idGrupoSuperficie"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.idGrupoSuperficie}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                                title="Grupo superficie"
                                                                entidad="GrupoSuperficie"
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-12 col-md-4">
                                                            <label htmlFor="idTipoObraSuperficie"
                                                                   className="form-label">Tipo de obra</label>
                                                            <InputLista
                                                                name="idTipoObraSuperficie"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.idTipoObraSuperficie}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                                lista="TipoObraSuperficie"
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-12 col-md-4">
                                                            <label htmlFor="idDestinoSuperficie"
                                                                   className="form-label">Destino</label>
                                                            <InputLista
                                                                name="idDestinoSuperficie"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.idDestinoSuperficie}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                                lista="DestinoSuperficie"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="mb-3 col-6 col-md-4">
                                                            <label htmlFor="fechaIntimacion"
                                                                   className="form-label">Intimación/Notificación</label>
                                                            <DatePickerCustom
                                                                name="fechaIntimacion"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.fechaIntimacion}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-4">
                                                            <label htmlFor="nroIntimacion"
                                                                   className="form-label">N°</label>
                                                            <input
                                                                name="nroIntimacion"
                                                                type="text"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.nroIntimacion}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-4">
                                                            <label htmlFor="nroAnterior" className="form-label">N°
                                                                Anterior</label>
                                                            <input
                                                                name="nroAnterior"
                                                                type="text"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.nroAnterior}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="mb-3 col-6 col-md-3">
                                                            <label htmlFor="fechaPresentacion"
                                                                   className="form-label">Presentación</label>
                                                            <DatePickerCustom
                                                                name="fechaPresentacion"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.fechaPresentacion}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-3">
                                                            <label htmlFor="fechaVigenteDesde"
                                                                   className="form-label">Vigente desde</label>
                                                            <DatePickerCustom
                                                                name="fechaVigenteDesde"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.fechaVigenteDesde}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-3">
                                                            <label htmlFor="fechaRegistrado"
                                                                   className="form-label">Registrado</label>
                                                            <DatePickerCustom
                                                                name="fechaRegistrado"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.fechaRegistrado}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-3">
                                                            <label htmlFor="fechaPermisoProvisorio"
                                                                   className="form-label">Permiso provisorio</label>
                                                            <DatePickerCustom
                                                                name="fechaPermisoProvisorio"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.fechaPermisoProvisorio}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-4">
                                                            <label htmlFor="fechaAprobacion"
                                                                   className="form-label">Aprobado</label>
                                                            <DatePickerCustom
                                                                name="fechaAprobacion"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.fechaAprobacion}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-4">
                                                            <CheckboxButtonGroup label="Obra">
                                                                <CheckboxButton
                                                                    name="conformeObra"
                                                                    label="Conforme a obra"
                                                                    checked={formValues.conformeObra}
                                                                    onChange={formHandle}
                                                                    disabled={props.disabled}
                                                                />
                                                            </CheckboxButtonGroup>
                                                        </div>
                                                        <div className="mb-3 col-6 col-md-4">
                                                            <label htmlFor="fechaFinObra" className="form-label">Fin
                                                                de obra</label>
                                                            <DatePickerCustom
                                                                name="fechaFinObra"
                                                                placeholder=""
                                                                className="form-control"
                                                                value={formValues.fechaFinObra}
                                                                onChange={formHandle}
                                                                disabled={props.disabled}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                            <hr className="solid m-bottom-10"></hr>
                                            <div className="row">
                                                <div className="mb-3 col-6 col-md-3">
                                                    <label htmlFor="ratificacion"
                                                           className="form-label">Ratificación</label>
                                                    <input
                                                        name="ratificacion"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.ratificacion}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                                <div className="mb-3 col-6 col-md-3">
                                                    <label htmlFor="derechos"
                                                           className="form-label">Derechos</label>
                                                    <input
                                                        name="derechos"
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control"
                                                        value={formValues.derechos}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de superficie"
                                            processKey={props.processKey}
                                            entidad="Superficie"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

SuperficieModal.propTypes = {
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

SuperficieModal.defaultProps = {
    disabled: false
};

export default SuperficieModal;